export default __webpack_public_path__ + "static/media/5.0db1f5e6.jpg";